import { Icon, IconButton } from '@chakra-ui/react';

export function FormatButton({
  label,
  icon,
  onClick,
  isActive,
}: {
  label: string;
  icon: React.ElementType;
  onClick: () => void;
  isActive: boolean;
}) {
  return (
    <IconButton
      aria-label={label}
      variant="ghost"
      colorScheme="gray"
      size="xs"
      icon={<Icon as={icon} />}
      onClick={onClick}
      isActive={isActive}
      _active={{ bg: 'brand.500', color: 'bg.surface' }}
    />
  );
}
